import React from 'react'

function Work() {
  return (
    <>
        <div className='skills'>
            <div className='container-fluid p-5'>
                <div className='all_skills work_div'>
                    
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/WQwZ8ZHl6vo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    
                    
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/ZlpDvzKHTA0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    
                    
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/LbXwSxk3utk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

                        <iframe width="560" height="315" src="https://www.youtube.com/embed/d0sZXxdNVEc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

                        <iframe width="560" height="315" src="https://www.youtube.com/embed/kOdFCGmkWJ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

                        <iframe width="560" height="315" src="https://www.youtube.com/embed/ggOE4jpgk8U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    
                </div>
            </div>
        </div>
    </>
  )
}

export default Work;